import React, { Component } from 'react'
import { Button, ProgressBar } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as actions from "../../store/actions/tabViewAction"
import { store } from '../../../..';
import { stopDownload } from '../../../../store/actions/fileDownloadActions';

export class DownloadIndicator extends Component {
  constructor(props) {
    super(props)
  }

  stopDownload = () => {
    store.dispatch(stopDownload())
  };

  render() {
    const { countOfDownloadSuccess, totalFilesToDownload, isDownloadInProgress } = this.props.downloadStatus;

    if (!isDownloadInProgress) {
      return null;
    }

    const completionPercentage = Math.trunc((countOfDownloadSuccess / totalFilesToDownload) * 100);

    return (
      <div style={{
        display: 'flex',
        height: '40px',
        width: '30%',
        margin: '6px auto',
        borderRadius: '4px',
        backgroundColor: '#fff',
        padding: '4px',
        justifyContent: 'center'
      }}>
        <Button bsStyle="primary" onClick={() => this.stopDownload()} style={{ marginRight: '5px' }}>
          Cancel
        </Button>
        <div style={{
          position: 'relative',
          flex: 1,
          height: '100%',
          display: 'flex',
        }}>
          <ProgressBar
            now={completionPercentage}
            bsStyle="success"
            style={{ width: '100%', height: '100%' }}
          />
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              textAlign: 'center',
              fontWeight: 'bold',
              color: 'black',
              lineHeight: '30px',
            }}
          >
            Downloading file - {countOfDownloadSuccess} of {totalFilesToDownload}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    downloadStatus: state.FileDownloadReducer
  };
};

export default connect(
  mapStateToProps,
)(DownloadIndicator);
